import * as types from "../types/deliveryInfo"

export const setDeliveryAreaName = (areaName, deliveryFee) => ({
  type: types.SET_DELIVERY_AREA_NAME,
  areaName,
  deliveryFee
})

export const changeDeliveryType = deliveryType => ({
  type: types.CHANGE_DELIVERY_TYPE,
  deliveryType
})

export const changeDeliveryAddress = deliveryAddress => ({
  type: types.CHANGE_DELIVERY_ADDRESS,
  deliveryAddress
})

export const clearDeliveryInfo = () => ({
  type: types.CLEAR_DELIVERY_INFO
})

export const clearDeliveryAddress = () => ({
  type: types.CLEAR_DELIVERY_ADDRESS
})

export const changeDeliveryService = (deliveryService) => ({
  type: types.CHANGE_DELIVERY_SERVICE,
  deliveryService
})

export const changeCinemaSolon = (cinemaSolonNumber) => ({
  type: types.SET_CINEMA_SOLON,
  cinemaSolonNumber
})